<template>
  <div>
    <div class="position-relative">
      <section class="section section-sm bg-custom-bg-color" style="margin-top: 90px">
        <div class="container p-0">

          <CatalogFilterBar :fetch-dates="Api.getHistoryDates" @change="onFilterChange"/>

          <div v-if="!isLoading && items.length === 0"
               class="text-main-color font-weight-500 text-center font-size-18">
            目前沒有歷史訂單
            <div class="mt-3"></div>
          </div>

          <div class="bg-white p-3 rounded-3" v-if="items.length > 0">
            <div>
              <h2 class="display-3 text-custom-text">歷史訂單</h2>
            </div>
            <div class="mt-3"></div>
            <div class="grid-container mx-5">
              <div v-for="(item, index) in items" :key="index" class="grid-item">
                <CatalogItem style="width: 212px;" :item="item"/>
              </div>
            </div>
            <IntersectionObserver
                sentinal-name="history-sentinel"
                @on-intersection-element="onIntersectionElement"
            />
            <div v-if="isLoadMore || finished" class="d-flex w-100 mt-3 justify-content-center align-items-center">
              <b-spinner v-if="isLoadMore" label="Loading..."></b-spinner>
              <p v-if="finished">已無更多資料</p>
            </div>
          </div>

        </div>
      </section>
    </div>
  </div>
</template>

<script>
import CatalogItem from "@/views/components/elements/CatalogItem";
import IntersectionObserver from "@/components/IntersectionObserver.vue";
import CatalogFilterBar from "@/components/CatalogFilterBar.vue";
import * as Api from "@/util/http_api";

export default {
  name: "HistoryView",
  components: {
    IntersectionObserver,
    CatalogItem,
    CatalogFilterBar,
  },
  data() {
    return {
      Api,
      // 篩選列（CatalogFilterBar）回報的條件；預設「全部」＝不篩日期
      filters: {keyword: '', dateField: undefined, dateValue: undefined},
      isLoading: false,
      finished: false,
      items: [],
      total_counts: 0,
      isIntersectingElement: false,
      isLoadMore: false,
      itemsPerPage: 24,
    };
  },
  async created() {
    await this.getDataFromApi();
  },
  methods: {
    // 篩選條件改變時，目前已載入的列表已經不一定有效，重置後重新查第一頁
    onFilterChange(filters) {
      this.filters = filters;
      this.items = [];
      this.total_counts = 0;
      this.finished = false;
      this.isLoadMore = false;
      this.getDataFromApi();
    },
    onIntersectionElement(value) {
      this.isIntersectingElement = value;
      this.loadMore();
    },
    currentFilterParams() {
      return {
        has_orders: true,
        keyword: this.filters.keyword,
        dateField: this.filters.dateField,
        dateValue: this.filters.dateValue,
      };
    },
    async loadMore() {
      if (this.isLoading || this.isLoadMore || this.finished) return;
      this.isLoadMore = true;
      const data = await Api.getHistoryCatalogs({
        ...this.currentFilterParams(),
        limit: this.itemsPerPage,
        offset: this.items.length,
      });
      for (let i = 0; i < data.items.length; i++) {
        this.items.push(data.items[i]);
      }
      this.isLoadMore = false;
      this.finished = this.items.length >= this.total_counts;
    },
    async getDataFromApi() {
      this.isLoading = true;
      try {
        const data = await Api.getHistoryCatalogs({
          ...this.currentFilterParams(),
          limit: this.itemsPerPage,
          offset: 0,
        });
        this.items = data.items;
        this.total_counts = data.total;
        this.finished = this.items.length >= this.total_counts;
      } catch (e) {
        console.error(e);
      }
      this.isLoading = false;
    },
  },
}
</script>

<style scoped>
.grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  grid-gap: 20px;
}

.grid-item {
  padding: 0;
}
</style>
